<template>
    <div class="content">
        <div class="rsk-p-xl">
        <div class="rsk-form-control">
            <h2 class="rsk-page-title rsk-mb-s">レポート</h2>
        </div>
        <rsk-tabs :list="['テスト', 'アンケート', 'レポート']" :modelValue="2" @onChange="tabsChange" />
        <div class="rsk-panel rsk-mb-m">
            <rsk-form v-model="form" :rules="rules" ref="formRef" cacheKey="reportCache">
                <rsk-form-item label="レポート名" annotation="（部分一致）" prop="reportName">
                    <rsk-input max="50" v-model="form.reportName" />
                </rsk-form-item>
                <rsk-form-item hintText="必須" label="ステータス" prop="status" isList>
                    <rsk-checkbox v-model="form.status" :options="[{label:'未提出', value:'0'}, {label:'提出済', value:'1'}]" />
                </rsk-form-item>
            </rsk-form>

            <rsk-form-submit>
                <rsk-button isExpand @click="refresh()" type="primary">検索</rsk-button>
                <rsk-button isExpand @click="clear" type="tertiary">クリア</rsk-button>
            </rsk-form-submit>
        </div>
        <rsk-table cacheKey="reportCache" :total="tableTotal" 
                   @init="tableConfigInit" @sortChange="tableChange"
                   @pageInfoChange="tableChange" :data="tableData" 
                   :titles="titles" ref="tableRef"
        />
        </div>
    </div>
</template>
<script>
import { dateFtt } from '@/utils/common'
import { ref, onMounted, inject, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import { checkInvalid } from '@/utils/validate'
import { full } from "@/utils/validateUtils";
import { tabsChangeEffect } from '../js/course'
import UAParser from 'ua-parser-js'
export default {

    setup() {

        const formRef = ref()
        const tableRef = ref();
        const tableTotal = ref(0)
        const form = ref({
            status: [0, 1]
        })
        const titles = ref([
        {
            field:'reportId',
            title:'ID',
            order:'asc'
            
        },
        {
            field:'reportName',
            title:'レポート名',
            order: 'none',
        },
        {
            field:'limitDate',
            title:'提出期限日',
            order: 'none',
        },
        {
            field:'reportFileName',
            title:'添付ファイル',
            order: 'none',
        },
        {
            field:'unitLearningProgressStr',
            title:'ステータス',
            order: 'none',
        },
        {
            field:'submitBeginTm',
            title:'提出日時',
            order: 'none',
        }
    ])
    
    const tableData = ref([])
    const route = useRoute();
    const router = useRouter()
    const { tabsChange } = tabsChangeEffect(router);
    onMounted(() => {
        localStorage.removeItem('reportLessonId')
        submit();
    })
    const service = inject("service");

    const rules =  ref(
        {
            reportName: [
                full('レポートは全角で入力してください'),
                { 
                    validator: (rule, value, callback) => {
                        const validateData = { invalidStr: value, isUnicoe: true }
                        checkInvalid(validateData, service, callback, 'レポート')
                    }
                },
                {
                    max: 50,
                    message: 'レポートは50文字以内で入力してください。'
                },
            ],
            status: [
                {
                    validator: (rule, value, callback) => {
                        if (form.value.status.length == 0) {
                            callback(new Error("ステータスを選択してください。"));
                        } else {
                            callback();
                        }
                    },
                },
            ],
        }
    )

    function downloadFile(filename,fileurl){
        const ua = new UAParser();
        let userAgent = ua.getUA();
        const downloadData = {filename:'',fileurl:'',userAgent:''}   
		downloadData.filename = filename;
		downloadData.fileurl = fileurl;
		downloadData.userAgent = userAgent;
		service.common.downloadFile(downloadData)
	}  

    function submit() {

        formRef.value.validate(form.value).then((resp) => {
            if (resp) {
                service.report.search({...pagingInfo, ...form.value,...columnInfo}).then(res => {
                res.list.forEach(item =>{
                    var reportName = item.reportName;
                    item.reportName = {
                        text:item.reportName,
                        callBack: function() {
                            if (item.studyFlg == '1') {
                                goSend(item.reportId, item.lessonId);
                            } else {
                                goConfirm(item.reportId, item.lessonId)
                            }                    
                        }
                    }
                    if (item.studyFlg == '0' && item.unitLearningProgressStr == '未提出') {
                        item.reportName = reportName; 
                    }
                    item.reportFileName = [
                        {
                            text: item.reportFileName1,
                            callBack: function() {
                                downloadFile(item.reportFileName[0].text, item.reportFileDir1);
                            }
                        },
                        {
                            text: item.reportFileName2,
                            callBack: function() {
                                downloadFile(item.reportFileName[1].text, item.reportFileDir2);
                            }
                        },                    
                    ]

                    if(item.submitBeginTm != null) {
                        item.submitBeginTm = dateFtt('yyyy/MM/dd hh:mm', item.submitBeginTm);
                    } else {
                        item.submitBeginTm = "-"
                    }

                    if(item.limitDate != null) {
                        item.limitDate = dateFtt('yyyy/MM/dd', item.limitDate);
                    } else {
                        item.limitDate = "-"
                    }
                })
                tableTotal.value = res.count
                tableData.value = res.list
                })
            }
        })
    }

    function refresh() {
        tableRef.value.search();
    }
    
    let pagingInfo = {}
    let columnInfo = {}
    function tableConfigInit(sorts, paging) {
        pagingInfo = paging
        if (sorts.column == 3) {
            if(sorts.order === '1') {
                sorts.column = 6
            } else {
                sorts.column = 7
            }
        }
        columnInfo = sorts;
    }
    var stopRequestFlag = false;
    function tableChange(sorts, paging) {     
        tableConfigInit(sorts, paging)
        if(!stopRequestFlag){
            submit()
        }
    }
    function goConfirm(report, lessonId) {
        if(lessonId == null) {
            lessonId = 0;
        }
        let id = report + "-" + lessonId
        router.push({
            name: 'reportConfirm',
            params: {
                id : id
            }
        })
    }
    function goSend(report, lessonId) {
        if(lessonId == null) {
            lessonId = 0;
        }
        let id = report + "-" + lessonId;
        router.push({
            name: 'reportSend',
            params: {
                id : id
            }
        })
    }

    function clear() {
      form.value = {};
      form.value.status = [0, 1];
      formRef.value.clear();
      tableRef.value.clear(); 
    }

    watch(()=>route.path,(to)=> {
        if(to !== '/listen/rep/confirm' && to !== '/listen/rep/send') {
            stopRequestFlag = true
            formRef.value.clear();
            tableRef.value.clear();
        }
    })

    return {
        submit,
        clear,
        tabsChange,
        tableChange,
        form,
        tableData,
        titles,
        rules,
        tableTotal,
        pagingInfo,
        tableConfigInit,
        formRef,
        tableRef,
        columnInfo,
        refresh
    }
}
}
</script>